import React from 'react';
import { Navigation } from '../components/Navigation';
import { Hero } from '../components/Hero';
import { EventDetails } from '../components/EventDetails';
import { Location } from '../components/Location';
import { RSVP } from '../components/RSVP';
import { Gift } from '../components/Gift';
import { Footer } from '../components/Footer';
import { HeartDivider } from '../components/Decorations';
import { useScreenInit } from '../useScreenInit';
export function Home() {
  useScreenInit();
  return <div className="min-h-screen relative" data-id="element-154">
      {/* Subtle background texture effect */}
      <div className="fixed inset-0 pointer-events-none opacity-[0.03] mix-blend-multiply" style={{
      backgroundImage: 'url("data:image/svg+xml,%3Csvg viewBox=%220 0 200 200%22 xmlns=%22http://www.w3.org/2000/svg%22%3E%3Cfilter id=%22noiseFilter%22%3E%3CfeTurbulence type=%22fractalNoise%22 baseFrequency=%220.65%22 numOctaves=%223%22 stitchTiles=%22stitch%22/%3E%3C/filter%3E%3Crect width=%22100%25%22 height=%22100%25%22 filter=%22url(%23noiseFilter)%22/%3E%3C/svg%3E")'
    }} data-id="element-155"></div>

      <Navigation data-id="element-156" />

      <main data-id="element-157">
        <Hero data-id="element-158" />
        <HeartDivider data-id="element-159" />
        <EventDetails data-id="element-160" />
        <Location data-id="element-161" />
        <RSVP data-id="element-162" />
        <Gift data-id="element-163" />
      </main>

      <Footer data-id="element-164" />
    </div>;
}